import type { EventType } from "app/types/eventType";
import store from "../store/store";
export class PositionMatrixHelper {
  static onClickPositionMatrix: (event: EventType) => void = (
    event: EventType
  ) => {
    store.dispatch.positionMatrixListModel.setPositionMatrixModalEvent(event);
    store.dispatch.positionMatrixListModel.setPositionMatrixModalItem({
      eventId: event.id,
    });
    store.dispatch.positionMatrixListModel.openPositionMatrixModal();
  };
}
